import {CheckInFormValues, validateRequiredChassisNumber, validateRequiredDriverFirstName, validateRequiredDriverLastName, validateRequiredDriverLicenseNumber, validateOptionalScacCode} from '../../util/check-in-field-validation';

/**
 * Validates the default fields for Chassis Only check-in.
 * Covers: CHASSIS_ONLY.
 * Required: chassisNumber, driverFirstName, driverLastName, driverLicenseNumber.
 */
export const validateChassisOnlyForm = (values: CheckInFormValues): string | undefined =>
  validateRequiredChassisNumber(values.chassisNumber) ??
  validateRequiredDriverFirstName(values.driverFirstName) ??
  validateRequiredDriverLastName(values.driverLastName) ??
  validateRequiredDriverLicenseNumber(values.driverLicenseNumber) ??
  validateOptionalScacCode(values.scacCode);
